function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amcharts/amcharts4/node_modules/@babel/runtime/helpers/classCallCheck.js
// module id = 3028
// module chunks = 1